// extracted by mini-css-extract-plugin
export default {"button":"columns_button__jiRiN","check":"columns_check__XF45n","x":"columns_x__7DprJ"};